import React from 'react';
import Spinner from 'react-bootstrap/Spinner'
import { FaShoppingBag } from 'react-icons/fa';
import Badge from '@material-ui/core/Badge';
import { connect } from 'react-redux';
import Tooltip from 'react-bootstrap/Tooltip';

export const ColoredLine = ({ color }) => (
	<div className="container mr-1 ml-1">
		<hr
			style={{
				color: color,
				backgroundColor: color,
				height: 1,
				opacity: 0.6
			}}
		/>
	</div>
);

export const numberFormat = (value) => {
	return new Intl.NumberFormat('de-DE').format(value);
};

export const Loading = () => {
   
	return (
			<div className='d-flex justify-content-center align-items-center' style={{height: '80vh'}}>
						<Spinner className='mr-3' animation="border" role="status" style={{color: 'rgb(244, 156, 52)'}}>
							<span className="sr-only">Cargando...</span>
					</Spinner>
					Cargando...
			</div>
			
	)
};

export const whatsAppText = (toggleWhatsAppMethod  , shoppingCart, shopName, total, whatsapp, name, direction, commune, region, commentary, deliveryPrice, deliveryState, dispatchTime, shopDirection) => {
	var text = ''

	if(deliveryState === false){
		 	text = text.concat('*RETIRO EN TIENDA* %0a %0a')
	} else{
		if(toggleWhatsAppMethod === false){
			text = text.concat('*DESPACHO* %0a %0a')
		} else{
			text = text.concat('*DESPACHO A COORDINAR* %0a %0a')
		}
	}

	text = text.concat(`¡Hola ${shopName}! %0a %0a`)

	text = text.concat(`Mi nombre es ${name} y me gustaría ordenar los siguientes productos: %0a %0a`)
	for (const i in shoppingCart) {
		text = text.concat(`- (${shoppingCart[i].quantity}) ${shoppingCart[i].name} ${shoppingCart[i].subCategory !== null ? `(${shoppingCart[i].subCategory})` : ''} ($ ${numberFormat(shoppingCart[i].price)})`)
		text = text.concat('%0a')
	}
		
	if(deliveryState === true){
        if(toggleWhatsAppMethod === false){
            text = text.concat(`%0aDelivery: *$ ${numberFormat(deliveryPrice)}* %0a`) 
		    text = text.concat(`%0aPor un total de: *$ ${numberFormat(parseInt(total) + parseInt(deliveryPrice))}* %0a %0a`)
        }
		text = text.concat(`%0a*Dirección:* ${direction} %0a`)
		text = text.concat(`*Comuna:* ${commune} %0a`)
		text = text.concat(`*Región:* ${region} %0a %0a`)
	} else{
		text = text.concat(`%0aPor un total de: *$ ${numberFormat(parseInt(total))}* %0a %0a`)
		text = text.concat(`*Dirección Tienda:* ${shopDirection} %0a`)
		text = text.concat(`*Información Adicional:* ${dispatchTime} %0a %0a`)
	}

	if(commentary !== ''){
		text = text.concat(`*Comentarios:* ${commentary} %0a %0a`)
	} else {
		text = text.concat(`%0a`)
	}

	text = text.concat(`¿Me podrías confirmar mi pedido por favor? %0a %0a`)
	text = text.concat(`Pedido a través de *SimpleQr* %0a`)


	const url_ = "https://wa.me/".concat(whatsapp).concat('?text=').concat(text)

	return url_
}

export const processText = (text) => {
	const textArray = text.split(' ');
	let finalText = '';
	let initialWord = true;
	for (let word of textArray) {
	  if (initialWord) {
		initialWord = false;
	  }
	  else {
		finalText += ' ';
	  }
	  if (word.length >= 15) {
		finalText += `${word.substring(0, 10)}-${word.substring(10)}`;
	  }
	  else{
		finalText += word;
	  }
	}
	return finalText;
}

export const renderTooltip = (deliveryInformation) => {
	return (
		<Tooltip id="button-tooltip">
			{deliveryInformation}
		</Tooltip>
	);
};

export const renderTooltip2 = (dispatchTime, shopDirection) => {
	
	return (
		<Tooltip id="button-tooltip">
			<p> Dirección Tienda: {shopDirection}  </p>
			<p> Información Adicional: {dispatchTime}  </p>
		</Tooltip>
	);
};

export const transformDelivery = (region) => {
	const object = 
		{
		'regionMetropolitana': 'Región Metropolitana',
		'tarapaca': 'Tarapacá',
		'antofagasta': 'Antofagasta',
		'atacama': 'Atacama',
		'coquimbo': 'Coquimbo',
		'valparaiso': 'Valparaíso',
		'ohiggins': "O' Higgins",
		'maule': 'Maule',
		'biobio': 'Bío Bío',
		'araucania': 'Araucanía',
		'losLagos': 'Los Lagos',
		'aysen': 'Aysen',
		'magallanes': 'Magalles',
		'losRios': 'Los Rios',
		'aricaParinacota': 'Arica y Parinacota'
	}

	return object[region]
}


const ShoppingCart = ({ shoppingCart, shopColor }) => {
	const shoppingCartLenght = shoppingCart.length;

	let totalItems = 0;
	shoppingCart.forEach((food) => {
		totalItems += food.quantity;
	});

	const showBadges =
		shoppingCartLenght !== 0 ? (
			<Badge className="custom-badge" color="secondary" badgeContent={totalItems} >
				<FaShoppingBag color={shopColor} size={30} />
			</Badge>
		) : (
			<FaShoppingBag color={shopColor} size={30} />
		);

	return <div> {showBadges} </div>
};

const mapStateToProps = (state) => ({
	shoppingCart: state.shoppingCart,
	shopColor: state.shopColor
});

export default connect(mapStateToProps, {})(ShoppingCart);